import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "simplePage"
};
const _hoisted_2 = { class: "left" };
const _hoisted_3 = { class: "mt-4" };
const _hoisted_4 = {
    key: 1,
    class: "simplePage"
};
const _hoisted_5 = { class: "left" };
const _hoisted_6 = { class: "mt-4" };
const _hoisted_7 = {
    key: 2,
    class: "simplePage"
};
const _hoisted_8 = {
    key: 3,
    class: "simplePage"
};
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useBanking } from '@/composables/useBanking';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import AccountsWidget from './elements/AccountsWidget.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'RelinkAccountsPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getBankingInfo, clearBankingInfo, reLinkAllBankAccounts } = useBanking();
        const relinkNeeded = ref(false);
        const accounts = ref([]);
        const attentionNeeded = ref([]);
        const attentionPerformed = ref(0);
        const busy = ref(false);
        const finished = ref(false);
        function onLoad() {
            getCustomer(() => {
                clearBankingInfo();
                getBankingInfo(() => {
                    state.bankInfo.accounts.forEach((a) => {
                        if (a.consentExpired) {
                            relinkNeeded.value = true;
                        }
                        accounts.value.push(a);
                    });
                });
            });
        }
        function relinkAccounts() {
            busy.value = true;
            reLinkAllBankAccounts((res) => {
                console.log("ReLinking accounts", res);
                accounts.value = [];
                var allOK = true;
                res.results.forEach((r) => {
                    if (r.success && !r.completed) {
                        allOK = false;
                        console.log("Adding to todo list", r);
                        var account = state.bankInfo.accounts.find((a) => a.bankDisplayName == r.bankDisplayName);
                        if (account != null) {
                            console.log("Found account", account);
                            accounts.value.push(account);
                            attentionNeeded.value.push(r);
                        }
                    }
                });
                clearBankingInfo();
                console.log("AllOK", allOK);
                if (allOK) {
                    console.log("All accounts are OK");
                    finished.value = true;
                }
                busy.value = false;
            });
        }
        function explicitBegin() {
            console.log("Explicit begin", attentionNeeded.value);
            busy.value = true;
            var todo = attentionNeeded.value[0];
            window.location.href = todo.actionUrl;
            attentionPerformed.value++;
            setTimeout(() => {
                attentionNeeded.value.shift();
                busy.value = false;
                if (attentionNeeded.value.length == 0) {
                    finished.value = true;
                }
            }, 2000);
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Keep Connected" }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).bankInfo
                }, null, 8, ["customer"]),
                (_unref(state).bankInfo && relinkNeeded.value && attentionNeeded.value.length == 0 && !finished.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _cache[3] || (_cache[3] = _createElementVNode("h1", null, "Refresh Account Permissions", -1)),
                        _createVNode(_component_v_icon, {
                            class: "smallHeroImg",
                            icon: "mdi-bank"
                        }),
                        _cache[4] || (_cache[4] = _createElementVNode("p", null, "To continue providing you with up-to-date information, we need you to refresh the permissions for your connected bank accounts.", -1)),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(AccountsWidget, {
                                title: "Pending Refresh",
                                accounts: accounts.value,
                                formatter: _unref(state).formatter,
                                hideSeeAll: true,
                                hideBalance: true,
                                unique: true
                            }, null, 8, ["accounts", "formatter"])
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            (!busy.value)
                                ? (_openBlock(), _createBlock(MGButton, {
                                    key: 0,
                                    text: "Begin",
                                    onClick: relinkAccounts
                                }))
                                : _createCommentVNode("", true),
                            (busy.value)
                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                    key: 1,
                                    indeterminate: "",
                                    size: "30",
                                    width: "3"
                                }))
                                : _createCommentVNode("", true),
                            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mt-3 small" }, "We will try to refresh automatically. However, some banks need you to grant permission.", -1))
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_unref(state).bankInfo && attentionNeeded.value.length > 0 && !finished.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _cache[5] || (_cache[5] = _createElementVNode("h1", null, "Refresh Account Permissions", -1)),
                        _createVNode(_component_v_icon, {
                            class: "smallHeroImg",
                            icon: "mdi-bank"
                        }),
                        _cache[6] || (_cache[6] = _createElementVNode("p", null, "The following accounts need your explicit permission. For each bank, you will be redirected to your banking app to allow this.", -1)),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(AccountsWidget, {
                                title: "Requires Attention",
                                accounts: accounts.value,
                                formatter: _unref(state).formatter,
                                hideSeeAll: true,
                                hideBalance: true,
                                unique: true
                            }, null, 8, ["accounts", "formatter"])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            (!busy.value)
                                ? (_openBlock(), _createBlock(MGButton, {
                                    key: 0,
                                    text: attentionPerformed.value == 0 ? 'Start' : 'Next',
                                    onClick: explicitBegin
                                }, null, 8, ["text"]))
                                : _createCommentVNode("", true),
                            (busy.value)
                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                    key: 1,
                                    indeterminate: "",
                                    size: "30",
                                    width: "3"
                                }))
                                : _createCommentVNode("", true)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_unref(state).bankInfo && !relinkNeeded.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _cache[7] || (_cache[7] = _createElementVNode("h1", null, "All your accounts are working correctly!", -1)),
                        _createVNode(_component_v_icon, {
                            class: "smallHeroImg",
                            icon: "mdi-bank-check"
                        }),
                        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "mt-4" }, "Nothing to see here. Go grab a coffee!", -1)),
                        _createVNode(MGButton, {
                            text: "Finish",
                            onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).back()))
                        })
                    ]))
                    : _createCommentVNode("", true),
                (finished.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _cache[9] || (_cache[9] = _createElementVNode("h1", null, "All Done!", -1)),
                        _createVNode(_component_v_icon, {
                            class: "smallHeroImg",
                            icon: "mdi-bank-check"
                        }),
                        _cache[10] || (_cache[10] = _createElementVNode("p", { class: "mt-4" }, "We've successfully refreshed all your account connections. You can now view your latest information.", -1)),
                        _createVNode(MGButton, {
                            text: "Finish",
                            onClick: _cache[1] || (_cache[1] = ($event) => { _unref(clearBankingInfo)(); _unref(router).back(); })
                        })
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
